import { mixed, object, string } from "yup"
import BasicBusinessInfo from "./views/BasicBusinessInfo";
import AdditionalInfo from "./views/AdditionalBusinnessInfo";
import ProprietorInfo from "./views/ProprietorInfo";

export default [
  {
    id: "basic_business_info",
    component: BasicBusinessInfo,
    initialValues: {
      business_name1: "",
      business_name2: "",
      business_name3: "",
      business_name4: "",
      business_nature: "",
      address: "",
      country: "",
      city: "",
      state: "",
      other_business_nature: "",
      success_status: "",
    },
    validationSchema: object().shape({
      business_name1: string().required("Provide a sample Business Name"),
      business_name2: string().required("Provide a sample Business Name"),
      business_name3: string().required("Provide a sample Business Name"),
      business_name4: string().required("Provide a sample Business Name"),
      business_nature: string().required("Kindly indicate type of Business"),
      address: string().required("Provide your business address"),
      country: string().required("Required"),
      city: string()
        .matches(/^[a-zA-Z\s]*$/, "City is invalid")
        .required("Indicate city where business location"),
      state: string().required("Kindly indicate state where business location"),
    }),
    actionLabel: "Next",
  },
  {
    id: "additional_info",
    component: AdditionalInfo,
    initialValues: {
      firstname: "",
      lastname: "",
      gender: "",
      proprietor_address: "",
      proprietor_state: "",
      proprietor_city: "",
      proprietor_email: "",
      proprietor_phone: "",
      nationality: "",
      dob: "",
      occupation: "",
      identity_type: "",
      identity_number: "",
      identity: "",
      signature: "",
      passport: "",
    },
    validationSchema: object().shape({
      firstname: string().required("Required"),
      lastname: string().required("Required"),
      gender: string().required("Required"),
      proprietor_email: string()
        .email("Must be a valid email address")
        .required("Required"),
      proprietor_phone: string()
        .matches(/^[0-9]{11}$/, "This phone number is Invalid")
        .required("Required"),
      proprietor_address: string().required("Required"),
      proprietor_state: string().required("Required"),
      proprietor_city: string()
        .matches(/^[A-Za-z]+$/, "City is invalid")
        .required("Required"),
      nationality: string().required("Required"),
      dob: string().required("Date of birth is required"),
      occupation: string().required("Occupation is required"),
      identity_type: string().required("Required"),
      identity_number: string().required("Required"),
      identity: string().required("A file is required"),
      signature: string().required("A file is required"),
      passport: string().required("A file is required"),
    }),
    actionLabel: "Next",
  },
  {
    id: "proprietor_info",
    component: ProprietorInfo,
    initialValues: {
      proprietor_company: "",
      company_name: "",
      company_address: "",
      company_country: "",
      company_state: "",
      company_city: "",
      rc_number: "",
      representative_name: "",
      representative_designation: "",
      representative_address: "",
      representative_country: "",
      representative_state: "",
      representative_city: "",
      representative_type: "",
      representative_number: "",
      representative_identity: "",
      cac_certificate: "",
    },
    validationSchema: object().shape({
      proprietor_company: string().required("Required"),
    }),
    actionLabel: "Confirm",
  },
]
